import axios from "axios";
const REST_API_BASE_URL = 'http://localhost:8080/webnet-hms/api/users';
export const EnterUserSer =(userData) => axios.post(REST_API_BASE_URL,userData);
export const getAllRoleIds = () => {
    return axios.get("http://localhost:8080/webnet-hms/api/roles");
  };
  
